<footer class="wrap-max-width mt-1 p-2 pb-0 pt-5">
  <div class="row d-flex justify-content-center">
    <div class="col-lg-2 center-elements-footer">
      <div class="col-12 text-center">
        <a href="/">
          <img class="logo-footer" src="/assets/logos/logo-footer.svg" alt="">
        </a>
      </div>
      <div class="w-100 d-flex justify-content-center">
        <div class="col-12 m-2" style="max-width: 198px;">
          <a href="https://www.instagram.com/canalblukit/?hl=pt-br" target="_blank">
            <img class="col-3 social-icons" src="/assets/icons/instagram_blue.svg" alt="">
          </a>
          <a href="https://pt-br.facebook.com/canalblukit/" target="_blank">
            <img class="col-3 social-icons" src="/assets/icons/facebook_blue.svg" alt="">
          </a>
          <a href="https://www.youtube.com/channel/UCV_SG6uvpUUKaTYnOspC__w" target="_blank">
            <img class="col-3 social-icons" src="/assets/icons/youtube_blue.svg" alt="">
          </a>
          <a href="https://www.linkedin.com/company/canalblukit/" target="_blank">
            <img class="col-3 social-icons" src="/assets/icons/linkedin_blue.svg" alt="">
          </a>
        </div>

      </div>
      <div class="d-lg-none m-2 mt-5 mb-5 text-center footer-title">
        <a routerLink="/home" class="footer-title p-2">Home</a>
        <a class="footer-title p-2" href="/linhas">Linha de Produtos</a>
        <a routerLink="/onde-encontrar" class="footer-title p-2">Onde Encontrar
        </a>
        <a routerLink="atendimento" class="footer-title p-2">Atendimento
        </a>
        <a routerLink="/sobre" class="footer-title p-2">Sobre a Blukit
        </a>
        <!-- <a routerLink="/blog" class="footer-title p-2">Blog
        </a> -->
      </div>

    </div>
    <div class="col-12 col-lg-2 center-elements-footer border border-bottom-0 border-top-0 m-lg-4 mb-0 mt-2 mt-lg-0">

      <p class="text-center phone-footer">
        <span style="font-size: 21px;">
          Atendimento
        </span>
        <br>

        <a href="tel:+554733310800" class="phone">
          47 <span>3331.0800</span>
        </a>

        <br>
        Seg a sex das 8h às 17h48
      </p>
    <div class="d-flex flex-column m-auto" style="max-width: 400px; font-size: 14px;">
      <a href="https://maps.app.goo.gl/5H15XyiaBs4SjDip7" target="_blank" class="footer-gray-light text-center">
        <span style="line-height: 1.2; font-size: 14px;">
          Blukit Metalúrgica (Matriz) <br>
          Rua João Pessoa - N° 2566 <br>
          CEP 89036-003 - Blumenau - SC
        </span>
      </a>
      <hr>
      <a href="https://maps.app.goo.gl/yXB16rUfMAphFyKk6" target="_blank" class="footer-gray-light text-center">
        <span style="line-height: 1.2; font-size: 14px;">
          Blukit Plásticos (Filial) <br>
          Rua Marconi - N° 310 <br>
          CEP 89066-030 - Blumenau - SC
        </span>
      </a>
      <hr>
      <a href="https://maps.app.goo.gl/cKkr96H6hKCECcj4A" target="_blank" class="footer-gray-light text-center mb-3">
        <span style="line-height: 1.2; font-size: 14px;">
          Blukit Centro de Distribuição<br>
          Rua Dr. Pedro Zimmermann - N° 7127 <br>
          CEP 89069-001 - Blumenau - SC
        </span>
      </a>
    </div>

    </div>

    <ul class="d-none d-lg-block col-2 ul-footer">
      <li class="mb-4 li-footer-title">
        <a class="footer-title" href="linhas">Linhas de Produtos</a>
      </li>
      <li class="my-2" *ngFor="let category of categories">
        <a class="footer-gray-light" href="{{category.link}}"
          >{{ category.nome }}
        </a>
      </li>

    </ul>
    <ul class="col-2 d-none d-lg-block ul-footer">
      <li class="mb-4 li-footer-title">
        <a class="footer-title" href="/atendimento">Atendimento</a>
      </li>
      <li class="my-2 ">
        <a class="footer-gray-light" href="/atendimento/fale-conosco"
          >Fale Conosco
        </a>
      </li>
      <li class="my-2 ">
        <a class="footer-gray-light" href="/atendimento/assistencia-tecnica"
          >Assistência Técnica
        </a>
      </li>
      <li class="my-2 ">
        <a class="footer-gray-light" href="atendimento/financeiro"
          >Financeiro
        </a>
      </li>
      <!-- <li class="my-2 ">
        <a class="footer-gray-light" target="_blank"
        href="http://novocurriculo.blukit.com.br:8080/novocurriculoweb/">Trabalhe
        na Blukit
        </a>
      </li> -->
      <li class="my-2 ">
        <a class="footer-gray-light" href="atendimento/duvidas-frequentes"
          >Dúvidas Frequentes
        </a>
      </li>
      <li class="my-2 ">
        <a class="footer-gray-light my-2"  href="atendimento/ouvidoria">Ouvidoria</a>
      </li>
      <li class="my-2 ">
        <a class="footer-gray-light my-2"  href="https://faleseguro.com.br/welcome?uuid=3941ff81-1ade-4673-ad17-0994d7bf5a41">Canal de Ética</a>
      </li>
    </ul>
    <ul class="col-1 d-none d-lg-block ul-footer">
      <li class="mb-4 li-footer-title">
        <a class="footer-title" href="/sobre">Sobre a Blukit</a>
      </li>
      <li class="my-2 ">
        <a class="footer-gray-light" href="/sobre/sobre-download"
          >Downloads
        </a>
      </li>
    </ul>
    <ul class="col-2 d-none d-lg-block ul-footer">
      <li class="mb-4 li-footer-title">
        <a class="footer-title" routerLink="/onde-encontrar">Onde encontrar</a>
      </li>
    </ul>
    <!-- <ul class="col-1 d-none d-lg-block ul-footer">
      <li class="mb-4 li-footer-title">
        <a class="footer-title" href="/blog">Blog</a>
      </li>
    </ul> -->

  </div>
</footer>
